/** Shared claim-note length and KX emission rules. */
/** Loop 2300 NTE02 max (1/80). */
export const CLAIM_NOTE_MAX_CHARS = 80;
export const KX_MODIFIER = 'KX';
/** KX is a period-of-care (0329) HIPPS modifier only. Never emit it on an NOA (032A). */
export function shouldEmitKxModifier(claimType, kxModifier) {
    return claimType === '0329' && kxModifier;
}
